import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { computed, inject } from '@angular/core';

import { UniversalHelpersClass } from '@senet-uiverse/common';
import { ECapability } from '@senet-id/core/enums';
import { ToastService } from '@senet-uiverse/ui';
import { IOffice } from '@senet-id/core/types';
import { EMPTY } from 'rxjs';

import {
  OrganizationService,
  DocumentsService,
  BookingService,
  ProfileService,
  StorageService,
  PassesService,
  TitleService,
} from './core/services';

export default abstract class SenetIdUniversalClass extends UniversalHelpersClass {
  private readonly titleService = inject(TitleService);

  readonly organizationService = inject(OrganizationService);
  readonly documentsService = inject(DocumentsService);
  readonly storageService = inject(StorageService);
  readonly profileService = inject(ProfileService);
  readonly bookingService = inject(BookingService);
  readonly passesService = inject(PassesService);
  readonly toastService = inject(ToastService);

  readonly hasBonusBalance = computed(() => {
    if (this.organizationService.newSubscriptionLogic()) {
      return this.organizationService.showBonusBalance();
    }

    return Boolean(this.storage().organizationInfo?.has_bonus_balance);
  });
  readonly organizationTitle = this.organizationService.selectedOrganizationTitle;
  readonly isUserBlocked = this.organizationService.isUserBlocked;
  readonly storage = this.storageService.storage;

  officeHasBonusBalance(office?: IOffice) {
    if (!this.organizationService.newSubscriptionLogic()) {
      return Boolean(this.storage().organizationInfo?.has_bonus_balance);
    }

    return !!office?.capabilities?.includes(ECapability.BonusBalance);
  }

  changeTitle(title: string) {
    this.titleService.change(title);
  }

  openDialog<T>(component: Promise<any>, context: any = {}) {
    return this.dialog.open<T>({
      component,
      config: {
        closeOnBackdropClick: false,
        closeOnEsc: false,
        context,
      },
      isObservable: true,
      successOnly: true,
    });
  }

  catchError(errorResponse: Readonly<HttpErrorResponse>) {
    if (errorResponse.error?.detail) {
      this.toastService.danger({ message: errorResponse.error.detail });
    } else if (errorResponse.status === HttpStatusCode.InternalServerError) {
      this.toastService.danger({
        title: this.translateService.instant('common.request.error.title'),
        message: this.translateService.instant('common.request.error.description'),
      });
    }

    return EMPTY;
  }
}
